<div class='wrap'>
  <ejs-slider #slider
              id='slider'
              [type]="rangeType"
              [min]="min"
              [max]="max"
              [value]="duration"
              [tooltip]="tooltipData"
              [ticks]="ticksData"
              [step]="step"
              [limits]="limitsData"
              (tooltipChange)='tooltipChangeHandler($event)'
              (renderingTicks)='renderingTicksHandler($event)'>
  </ejs-slider>
</div>
